import type { SVGProps } from 'react';

import { assignInlineVars } from '@vanilla-extract/dynamic';

import { clsx } from '~/styles/utils';

import { iconSize, iconSizeStyle, iconStyles } from './Icon.css';
import * as Icons from './svgs';

export type IconName = keyof typeof Icons;

type Props = SVGProps<SVGSVGElement> & {
  inline?: boolean;
  name: IconName;
  size?: number;
};

export const Icon = ({ inline = false, name, size = 24, ...delegated }: Props) => {
  const Component = Icons[name];

  return (
    <Component
      {...delegated}
      aria-hidden={delegated['aria-hidden'] ?? true}
      className={clsx(inline ? iconStyles.inline : iconStyles.block, iconSizeStyle, delegated.className)}
      style={{ ...assignInlineVars({ [iconSize]: `${size}px` }), ...delegated.style }}
    />
  );
};
